import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./screen.css";
import "./styles.css";
import "./EditUser.css"; // Add this new CSS file for styles
import Loader from "./Loader";
import Sidebar from "./SideBar";
const API_URL = process.env.REACT_APP_API_URL;
const LOGIN_API_URL = process.env.REACT_APP_LOGIN_API_URL;
function EditUser() {
  const location = useLocation();
  const [password, setpassword] = useState(location?.state?.card?.password);
  const [role, setRole] = useState(location?.state?.card?.role);
  const [name, setname] = useState(location?.state?.card?.username || "");
  const [organization, setorganization] = useState(
    location?.state?.card?.organization || ""
  );
  const [phone, setphone] = useState(location?.state?.card?.phone || "");
  const [userId, setUserId] = useState("");
  const [currentRole, setCurrentRole] = useState("");
  const [data, setdata] = useState([]);
  const [data2, setdata2] = useState([]);
  const [loading, setloading] = useState(true);

  const [selectedDevices, setSelectedDevices] = useState([]);
  const getmac = async () => {
    const userId = localStorage.getItem("loginId");
    const role = localStorage.getItem("role");
    setCurrentRole(role);
    setUserId(userId);

    fetch(`${API_URL}/index.php?getmac=true`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        let filter = responseData.filter((user) => !user.userid);
        let filter2 = responseData.filter(
          (user) => user.userid === location?.state?.card?.loginId
        );
        setdata(filter);
        setdata2(filter2);
        //console.log(data2, "####");
        setloading(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getmac();
    // eslint-disable-next-line
  }, []);

  const adduser = async () => {
    if (!location?.state?.card?.email || !password || !role) {
      alert("Please fill all the fields.");
      return;
    }

    fetch(`${LOGIN_API_URL}/login.php`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        upid: location?.state?.card?.loginId,
        uppassword: password,
        uprole: role,
        uporganization: organization,
        upphone: phone,
        upusername: name,
      }),
    })
      .then((response) => response.json())
      .then(() => {
        for (const mac of selectedDevices) {
          fetch(`${API_URL}/index.php`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              assignuser: location?.state?.card?.loginId,
              assignmac: mac,
            }),
          });
        }
        //navigate("/alluser");
        getmac();
        alert("Updated");
      })
      .catch((err) => console.log(err));
  };

  return (
    <div style={{ display: "flex", height: "100vh", width: "100%" }}>
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          padding: "30px",
          backgroundColor: "#fff",
          overflowY: "auto",
        }}
      >
        {/* Header (optional) */}
        <h1 style={{ marginBottom: 30, fontSize: "30px" }}>Edit User</h1>

        <div
          style={{
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "12px",
            maxWidth: "700px",
            margin: "0 auto",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          {/* Email */}

          <div style={{ marginBottom: 20 }}>
            <label
              style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
            >
              Username
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setname(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #ccc",
                outline: "none",
                fontSize: "100%",
              }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label
              style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
            >
              Email
            </label>
            <input
              type="text"
              disabled
              value={location?.state?.card?.email}
              style={{
                width: "100%",
                padding: "10px 14px",
                borderRadius: 8,
                border: "1px solid #ccc",
                fontSize: "100%",
                backgroundColor: "#f0f0f0",
              }}
            />
          </div>

          {/* Password & Role (non-Technician only) */}
          {currentRole !== "Technician" && (
            <>
              <div style={{ marginBottom: 20 }}>
                <label
                  style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
                >
                  Password
                </label>
                <input
                  type="text"
                  value={password}
                  onChange={(e) => setpassword(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: 8,
                    border: "1px solid #ccc",
                    fontSize: "100%",
                    color: "#000",
                  }}
                />
              </div>

              <div style={{ marginBottom: 30 }}>
                <label
                  style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
                >
                  Role
                </label>
                <select
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: 8,
                    border: "1px solid #ccc",
                    fontSize: "100%",
                    backgroundColor: "#fff",
                  }}
                >
                  <option value="" disabled hidden>
                    Select Role
                  </option>
                  <option value="Product Manager">Product Manager</option>
                  <option value="Site Manager">Site Manager</option>
                  <option value="Technician">Technician</option>
                  <option value="User">User</option>
                </select>
              </div>

              <div style={{ marginBottom: 20 }}>
                <label
                  style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
                >
                  Phone
                </label>
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => setphone(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: 8,
                    border: "1px solid #ccc",
                    outline: "none",
                    fontSize: "100%",
                  }}
                />
              </div>

              <div style={{ marginBottom: 20 }}>
                <label
                  style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
                >
                  Organization
                </label>
                <input
                  type="text"
                  value={organization}
                  onChange={(e) => setorganization(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 14px",
                    borderRadius: 8,
                    border: "1px solid #ccc",
                    outline: "none",
                    fontSize: "100%",
                  }}
                />
              </div>
            </>
          )}

          {/* Devices for Users */}
          {location?.state?.card?.role === "User" && (
            <div style={{ marginBottom: 30 }}>
              <label
                style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
              >
                Assigned Devices
              </label>
              {data2?.map((item, index) =>
                loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Loader message="Please Wait..." />
                  </div>
                ) : (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 10,
                    }}
                  >
                    <textarea
                      onClick={() => {
                        if (
                          currentRole === "User" ||
                          currentRole === "Technician"
                        ) {
                          // navigate("/view", {
                          //   state: { id: item?.mac_address },
                          // });
                        }
                      }}
                      key={index}
                      rows={2}
                      readOnly
                      value={`${item?.name}\n${item?.mac_address}`}
                      style={{
                        width: "100%",
                        marginBottom: 10,
                        padding: "10px",
                        borderRadius: 8,
                        border: "1px solid #ccc",
                        backgroundColor: "#f9f9f9",
                        fontSize: "100%",
                        cursor: "pointer",
                      }}
                    />
                    {currentRole !== "User" && (
                      <img
                        onClick={() => {
                          if (
                            window.confirm(
                              "Are you sure you want to remove this device for this user?"
                            )
                          ) {
                            fetch(`${API_URL}/index.php`, {
                              method: "POST",
                              headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                              },
                              body: JSON.stringify({
                                assignuser: "",
                                assignmac: item?.mac_address,
                              }),
                            })
                              .then((res) => res.json())
                              .then((res) => {
                              //  console.log("Device removed:", res);
                                getmac();
                                // optionally refresh list:
                                // setData2(prev => prev.filter(d => d.mac_address !== item?.mac_address));
                              })
                              .catch((err) =>
                                console.error("Error removing device:", err)
                              );
                          }
                        }}
                        src={require("../img/delete.png")}
                        style={{ width: "20px", height: "20px" }}
                        alt="edit"
                      />
                    )}
                  </div>
                )
              )}
            </div>
          )}

          {/* Devices for Technicians */}
          {currentRole !== "User" && (
            <>
              <label
                style={{ display: "block", fontWeight: 600, marginBottom: 6 }}
              >
                Unassigned Devices
              </label>
              {data.length === 0 ? (
                <h3 style={{ color: "#000" }}>No new device is available</h3>
              ) : (
                <div style={{ overflowX: "auto", marginBottom: 30 }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "100%",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#e0e7ff",
                          color: "#333",
                          textAlign: "left",
                        }}
                      >
                        <th style={{ padding: "10px" }}>Name</th>
                        <th style={{ padding: "10px" }}>MAC</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item, index) => {
                        const isChecked = selectedDevices.includes(
                          item?.mac_address
                        );
                        const showRow =
                          currentRole !== "User" || item?.userid === userId;

                        return showRow ? (
                          <tr
                            key={index}
                            style={{ borderBottom: "1px solid #ddd" }}
                          >
                            <td style={{ padding: "10px" }}>
                              <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={(e) => {
                                  const updatedDevices = [...selectedDevices];
                                  if (e.target.checked) {
                                    updatedDevices.push(item?.mac_address);
                                  } else {
                                    const idx = updatedDevices.indexOf(
                                      item?.mac_address
                                    );
                                    if (idx > -1) updatedDevices.splice(idx, 1);
                                  }
                                  setSelectedDevices(updatedDevices);
                                }}
                              />{" "}
                              {item?.name}
                            </td>
                            <td style={{ padding: "10px" }}>
                              {item?.mac_address}
                            </td>
                          </tr>
                        ) : null;
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}

          {/* Submit Button */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              onClick={adduser}
              style={{
                padding: "12px 50px",
                background: "linear-gradient(135deg, #005ecb, #005ecb)",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                fontSize: "100%",
                fontWeight: "bold",
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                transition: "background 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#8ec5fc")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  "linear-gradient(135deg, #005ecb, #005ecb)")
              }
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditUser;
